module.exports = __webpack_public_path__ + "img/jt.3e53e24b.png";